export const supportedLngs = ['en', 'ru'] as const;
export type Language = typeof supportedLngs[number];
export const lookupLocalStorage = 'i18nextLng';
export const lookupCookie = 'django_language';

export function getLocalLanguage(): Language {
  return localStorage.getItem(lookupLocalStorage) || 'ru' as any;
}
